
import common from './ko_KR/common'
import areaCode from './ko_KR/areaCode'
import communicateCenter from './ko_KR/communicateCenter'
import components from './ko_KR/components'
import course from './ko_KR/course'
import courseDetail from './ko_KR/courseDetail'
import examDetail from './ko_KR/examDetail'
import home from './ko_KR/home'
import humanTraining from './ko_KR/humanTraining'
import inforList from './ko_KR/inforList'
import Information from './ko_KR/Information'
import intelligentOfficialDoc from './ko_KR/intelligentOfficialDoc'
import knowledgeLib from './ko_KR/knowledgeLib'
import LearnRecords from './ko_KR/LearnRecords'
import Login from './ko_KR/Login'
import myCourse from './ko_KR/myCourse'
import myExam from './ko_KR/myExam'
import mynews from './ko_KR/mynews'
import mySetting from './ko_KR/mySetting'
import mytopic from './ko_KR/mytopic'
import myTrainingClass from './ko_KR/myTrainingClass'
import myTrainingDetail from './ko_KR/myTrainingDetail'
import myWork from './ko_KR/myWork'
import post from './ko_KR/post'
import postDetail from './ko_KR/postDetail'
import practiceTrain from './ko_KR/practiceTrain'
import publicExam from './ko_KR/publicExam'
import questionnaire from './ko_KR/questionnaire'
import rules from './ko_KR/rules'
import search from './ko_KR/search'
import studyMap from './ko_KR/studyMap'
import topic from './ko_KR/topic'
import topicDetail from './ko_KR/topicDetail'
import topicManagerRange from './ko_KR/topicManagerRange'
import trainingClass from './ko_KR/trainingClass'
import trainingCourseDetail from './ko_KR/trainingCourseDetail'
import webLive from './ko_KR/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}
